import { Component, Input } from '@angular/core';

import castArray from 'lodash-es/castArray';

@Component({
  selector: 'app-text-list',
  templateUrl: './text-list.component.html',
  styleUrls: ['./text-list.component.scss'],
})
export class TextListComponent {
  @Input() set list(value: string | string[]) {
    this.sanitizedList = castArray(value);
  }
  sanitizedList: string[];
}
